import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";

const styles = (theme) => ({
  img: {
    width: '100%',
  },
  accent: {
    fontWeight: 'bold'
  }
});

class About extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <h1>Om föreningen</h1>
        <Grid container spacing={4}>
          <Grid item sm={6} md={8}>
            <p>
              Voxette är en ideell förening som bedriver damkörsång.
            </p>
            <p>
              Föreningens ändamål är att bedriva konstnärlig verksamhet i form av körsång via repetitioner och musikaliska projekt, exempelvis egna konserter, samproduktioner med andra körer och musiker, körresor samt pro bono-sånguppdrag.
            </p>
            <p>
              Körens målsättning är att beröra i ton och närvaro och att musicera på hög nivå utifrån en bred repertoarpalett.
            </p>
            <p>
              <span className={classes.accent}>Org.nr:</span> <br />875003-0796
            </p>
            <p>
              <span className={classes.accent}>Postadress: </span>
              <br />
              c/o SARA RÖNNBÄCK,<br /> Kalle Posts Väg 74,<br /> 702 29 Örebro
            </p>
          </Grid>
          <Grid item sm={6} md={4}>
            <img className={classes.img} alt="Voxette" src="/images/voxette.png" />
          </Grid>
        </Grid>
      </div>
    );
  }
}

About.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(About);
